import axios from 'axios';

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || '/api/admin',
  timeout: 10000,
});

instance.interceptors.request.use(config => {
  const token = localStorage.getItem('admin_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

instance.interceptors.response.use(
  response => {
    const res = response.data;
    // 登录成功直接返回 data（包含 token 和 admin 信息）
    if (res.code === 200) {
      return res.data;
    }
    // 处理非 200 的响应
    // 如果是登录接口且返回 401，只 reject 错误，不跳转
    if (res.code === 401 && response.config.url.includes('/login')) {
      return Promise.reject(new Error(res.msg || '登录失败'));
    }
    // 其他接口的 401，清除 token 并跳转登录
    if (res.code === 401) {
      localStorage.removeItem('admin_token');
      window.location.href = '/login';
      return Promise.reject(new Error('请重新登录'));
    }
    // 其他错误
    return Promise.reject(new Error(res.msg || '请求失败'));
  },
  error => {
    // 网络错误或超时
    console.error('请求异常:', error);
    return Promise.reject(error);
  }
);

export default instance;